<template>
  <div>
    <!--Header-->
    <div class="header pb-6 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-default opacity-8"></span>
    </div>
    <section class="section section-lg pt-6 pb-7" :style="{'background-image': bannerColor}" id="welcome">
      <b-container class="pb-6">
        <div v-if="affiliate" class="text-center mb-3">
          <img :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + affiliate.logo" style="max-width: 300px;" />
        </div>
        <div v-else>
          <h1 class="mb-0" style="font-size: 35px;"><span :style="[enterprise ? {'color': enterprise.secondary_color} : {'color': '#D45E5E'}]">Hey</span> <span class="text-white">{{ user.name }}</span></h1>
          <p class="text-white">Here are some tools and tips about your ClarityNOW portal.</p>
        </div>
      </b-container>
    </section>
    <section class="section section-lg mt--9">
      <b-container>
        <b-row class="mb-4">
          <b-col md="8">
            <b-card class="bg-gradient-clarity2" :style="{'background-image': checkEnterprise}">
              <!-- Card body -->
              <b-card-body>
                <b-row v-if="enterprise">
                  <b-col v-if="enterprise.logo">
                    <img :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + enterprise.logo" style="width: 100%" />
                  </b-col>
                  <b-col class="d-flex flex-column my-auto">
                    <b-button block size="lg" variant="outline-clarity" @click="goToDashboard" :style="{'border-color': enterprise.primary_color, 'color': enterprise.primary_color}" v-if="portalAccess">
                      <div class="mb-2">
                        <i class="fas fa-3x fa-tachometer-alt text-black"></i>
                      </div>
                      <span style="font-size: 18px;">DASHBOARD</span>
                    </b-button>
                    <b-button block size="lg" variant="outline-clarity" :to="'/observatory'" :style="{'border-color': enterprise.primary_color, 'color': enterprise.primary_color}" v-if="observatoryAccess">
                      <div class="mb-2">
                        <i class="fas fa-3x fa-eye text-black"></i>
                      </div>
                      <span style="font-size: 18px;">OBSERVATORY</span>
                    </b-button>
                    <b-button block size="lg" variant="outline-clarity" :to="'/enterprise/dashboard'" :style="{'border-color': enterprise.primary_color, 'color': enterprise.primary_color}" v-if="enterpriseAccess">
                      <div class="mb-2">
                        <i class="fas fa-3x fa-building text-black"></i>
                      </div>
                      <span style="font-size: 18px;">ENTERPRISE</span>
                    </b-button>
                  </b-col>
                </b-row>
                <b-row class="justify-content-center" v-else>
                  <b-col md="4" v-if="enterpriseCreated || enterpriseAccess" class="text-center">
                    <b-button block size="lg" variant="outline-clarity" :to="'/enterprise/dashboard'">
                      <div class="mb-2">
                        <i class="fas fa-3x fa-building text-clarity"></i>
                      </div>
                      <span style="font-size: 18px;">ENTERPRISE</span>
                    </b-button>
                  </b-col>
                  <b-col md="4" v-if="coachingCreated" class="text-center">
                    <b-button block size="lg" variant="outline-clarity" :to="'/coaching/dashboard'">
                      <div class="mb-2">
                        <i class="fas fa-3x fa-user-graduate text-clarity"></i>
                      </div>
                      <span style="font-size: 18px;">ENTERPRISE COACHING</span>
                    </b-button>
                  </b-col>
                  <b-col md="4" v-if="portalAccess" class="text-center">
                    <b-button block size="lg" variant="outline-clarity" @click="goToDashboard">
                      <div class="mb-2">
                        <i class="fas fa-3x fa-tachometer-alt text-clarity"></i>
                      </div>
                      <span style="font-size: 18px;">DASHBOARD</span>
                    </b-button>
                  </b-col>
                  <b-col md="4" v-if="observatoryAccess" class="text-center">
                    <b-button block size="lg" variant="outline-clarity" :to="'/observatory'">
                      <div class="mb-2">
                        <i class="fas fa-3x fa-eye text-black"></i>
                      </div>
                      <span style="font-size: 18px;">OBSERVATORY</span>
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>

            <h4 class="text-uppercase">Product Features</h4>
            <b-card no-body>
              <b-card-body class="d-flex justify-content-between align-items-center">
                <div class="w-75">
                  <span class="fa-stack fa-2x text-cblue ml--3 float-left">
                    <i class="fas fa-square fa-stack-2x"></i>
                    <i class="fas fa-key fa-stack-1x fa-inverse"></i>
                  </span>
                  <div class="pt-2">
                    <p class="mb-0 small"><strong>KEY FEATURES</strong></p>
                    <h3 class="mb-0">How to use ClarityNOW to run your business.</h3>
                  </div>
                </div>
                <div>
                  <b-button pill variant="outline-clarity" @click="watchSection('features')" class="d-none d-lg-block">WATCH NOW</b-button>
                  <b-button pill variant="link" @click="watchSection('features')" href="#" class="d-block d-lg-none">
                    <i class="fas fa-circle-play fa-3x text-clarity"></i>
                  </b-button>
                </div>
              </b-card-body>
            </b-card>
            <b-card no-body>
              <b-card-body class="d-flex justify-content-between align-items-center">
                <div class="w-75">
                  <span class="fa-stack fa-2x text-cgray ml--3 float-left">
                    <i class="fas fa-square fa-stack-2x"></i>
                    <i class="fas fa-handshake fa-stack-1x fa-inverse"></i>
                  </span>
                  <div class="pt-2">
                    <p class="mb-0 small"><strong>AGENT 1:1</strong></p>
                    <h3 class="mb-0">How to do an agent 1:1 using ClarityNOW.</h3>
                  </div>
                </div>
                <div>
                  <b-button pill variant="outline-clarity" @click="watchSection('agents')" class="d-none d-lg-block">WATCH NOW</b-button>
                  <b-button pill variant="link" @click="watchSection('agents')" href="#" class="d-block d-lg-none">
                    <i class="fas fa-circle-play fa-3x text-clarity"></i>
                  </b-button>
                </div>
              </b-card-body>
            </b-card>
            <b-card no-body>
              <b-card-body class="d-flex justify-content-between align-items-center">
                <div class="w-75">
                  <span class="fa-stack fa-2x text-clight-blue ml--3 float-left">
                    <i class="fas fa-square fa-stack-2x"></i>
                    <i class="fas fa-calendar fa-stack-1x fa-inverse"></i>
                  </span>
                  <div class="pt-2">
                    <p class="mb-0 small"><strong>TEAM MEETINGS</strong></p>
                    <h3 class="mb-0">How to use ClarityNOW for running your team meetings.</h3>
                  </div>
                </div>
                <div>
                  <b-button pill variant="outline-clarity" @click="watchSection('meetings')" class="d-none d-lg-block">WATCH NOW</b-button>
                  <b-button pill variant="link" @click="watchSection('meetings')" href="#" class="d-block d-lg-none">
                    <i class="fas fa-circle-play fa-3x text-clarity"></i>
                  </b-button>
                </div>
              </b-card-body>
            </b-card>
            <b-card no-body>
              <b-card-body class="d-flex justify-content-between align-items-center">
                <div class="w-75">
                  <span class="fa-stack fa-2x text-corange ml--3 float-left">
                    <i class="fas fa-square fa-stack-2x"></i>
                    <i class="fas fa-money-check-dollar fa-stack-1x fa-inverse"></i>
                  </span>
                  <div class="pt-2">
                    <p class="mb-0 small"><strong>MANAGE FINANCES</strong></p>
                    <h3 class="mb-0">How to use ClarityNOW to manage your finances.</h3>
                  </div>
                </div>
                <div>
                  <b-button pill variant="outline-clarity" @click="watchSection('finances')" class="d-none d-lg-block">WATCH NOW</b-button>
                  <b-button pill variant="link" @click="watchSection('finances')" href="#" class="d-block d-lg-none">
                    <i class="fas fa-circle-play fa-3x text-clarity"></i>
                  </b-button>
                </div>
              </b-card-body>
            </b-card>
            <b-card no-body>
              <b-card-body class="d-flex justify-content-between align-items-center">
                <div class="w-75">
                  <span class="fa-stack fa-2x text-clight-gray ml--3 float-left">
                    <i class="fas fa-square fa-stack-2x"></i>
                    <i class="fas fa-list-check fa-stack-1x fa-inverse"></i>
                  </span>
                  <div class="pt-2">
                    <p class="mb-0 small"><strong>BUSINESS PLANNING</strong></p>
                    <h3 class="mb-0">How to do business planning in ClarityNOW.</h3>
                  </div>
                </div>
                <div>
                  <b-button pill variant="outline-clarity" @click="watchSection('planning')" class="d-none d-lg-block">WATCH NOW</b-button>
                  <b-button pill variant="link" @click="watchSection('planning')" href="#" class="d-block d-lg-none">
                    <i class="fas fa-circle-play fa-3x text-clarity"></i>
                  </b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col md="4">
            <div v-if="enterprise">
              <b-card
                no-body
                v-if="enterprise.vendors" 
                v-for="vendor in enterprise.vendors" :key="vendor.id"
                :img-src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + vendor.logo"
                :img-alt="vendor.name">
                <b-card-body class="p-0">
                  <a :href="vendor.url" target="_blank" class="stretched-link"></a>
                </b-card-body>
              </b-card>
            </div>

            <b-card no-body>
              <b-card-body>
                <b-row class="py-2 d-flex align-items-center">
                  <b-col md="5">
                    <img src="/img/brand/daily-clarity.png" style="width: 100%;" />
                  </b-col>
                  <b-col class="text-center">
                    <h3>Join our Facebook group!</h3>
                    <b-button block href="https://www.facebook.com/groups/dailyclarity/" target="_blank" variant="outline-clarity">Daily Clarity</b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>

            <b-card no-body class="bg-gradient-danger">
              <b-card-body class="text-center">
                <h2 class="text-white">Refer a Friend</h2>
                <p v-if="subscribed" class="text-white">Get $10 when they Sign Up.</p>
                <b-button variant="outline-clarity" v-b-modal.referral-modal>Invite Now</b-button>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="mb-5" v-if="affiliate">
          <b-col md="4">
            <div class="mb-4" v-if="affiliate.video_url">
                <b-embed
                    type="iframe"
                    aspect="16by9"
                    :src="affiliate.video_url"
                    controls
                    allowfullscreen
                ></b-embed>
            </div>
            <div class="text-center mb-5">
              <b-button :href="affiliate.btn1_url" class="btn" target="_blank" :style="{'background-color': affiliate.header_color, color: '#ffffff'}" v-if="affiliate.btn1_txt">
                {{ affiliate.btn1_txt }}
              </b-button>
              <b-button :href="affiliate.btn2_url" class="btn" target="_blank" :style="{'background-color': affiliate.header_color, color: '#ffffff'}" v-if="affiliate.btn2_txt">
                {{ affiliate.btn2_txt }}
              </b-button>
            </div>
          </b-col>
          <b-col md="4" v-if="affiliate.events || affiliate.future_events">
            <div v-if="affiliate.events">
              <h4 class="text-uppercase">Next Event</h4>
              <b-card no-body :img-src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + affiliate.next_event_img">
                <b-card-body>
                  <div v-html="affiliate.next_event_desc"></div>
                </b-card-body>
              </b-card>
            </div>
            <div v-if="affiliate.future_events">
              <h4 class="text-uppercase">Future Events</h4>
              <b-card no-body>
                <b-card-body>
                  <div v-html="affiliate.future_events"></div>
                </b-card-body>
              </b-card>
            </div>
          </b-col>
          <b-col md="4" v-if="affiliate.calendar_url">
            <h4 class="text-uppercase">{{ affiliate.name }}'s Calender</h4>
            <b-card no-body>
              <div class="calendly-inline-widget" :data-url="affiliate.calendar_url" style="min-width:220px;height:500px;"></div>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <referral-modal></referral-modal>
    <home-videos :section="this.section"></home-videos>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import ReferralModal from '@/views/Components/Modals/ReferralModal';
import HomeVideos from '@/views/Components/Modals/HomeVideos';

export default {
  name: 'home-page',
  components: {
    ReferralModal,
    HomeVideos
  },
  data() {
    return {
      year: new Date().getFullYear(),
      section: null,
    }
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      userRoute: 'profile/userRoute',
      roles: 'roles/roles',
      affiliate: 'profile/affiliate',
      enterprise: 'profile/enterprise',
      enterpriseCreated: 'profile/enterpriseCreated',
      coachingCreated: 'profile/coachingCreated',
      subBasic: 'profile/subBasic',
      subStandard: 'profile/subStandard',
      subPremium: 'profile/subPremium',
    }),
    owner() {
      return this.roles.includes('owner');
    },
    agent() {
      return this.roles.includes('agent');
    },
    editor() {
      return this.roles.includes('editor');
    },
    viewer() {
      return this.roles.includes('viewer');
    },
    enterpriseRole() {
      return this.roles.includes('enterprise');
    },
    subscribed() {
      return this.subBasic || this.subStandard || this.subPremium;
    },
    columnSize() {
      return this.owner || this.agent ? 8 : 12
    },
    headerColor() {
      return this.affiliate ? 'linear-gradient(87deg, ' + this.affiliate.header_color + ' 40%, #aaaaaa 300%) !important' : '';
    },
    bannerColor() {
      if (this.affiliate) {
        return 'linear-gradient(87deg, ' + this.affiliate.header_color + ' 40%, #aaaaaa 300%) !important';
      }

      if (this.enterprise) {
        return 'linear-gradient(87deg, ' + this.enterprise.primary_color + ' 40%, #aaaaaa 300%) !important'
      }

      return '';
    },
    textColor() {
      return this.affiliate && this.affiliate.banner_color !== '#ffffff' ? '#ffffff' : '';
    },
    btnVariant() {
      return 'outline-danger';
    },
    completedSuccess() {
      const completed = Object.values(this.progress).filter(complete => {
        return complete == true;
      });

      return Object.keys(completed).length == Object.keys(this.progress).length;
    },
    portalAccess() {
      return this.owner || this.agent;
    },
    observatoryAccess() {
      return this.owner || this.editor || this.viewer;
    },
    enterpriseAccess() {
      return this.roles.includes('enterprise');
    },
    checkEnterprise() {
      if (this.enterprise) {
        return 'linear-gradient(87deg, ' + this.enterprise.secondary_color + ', #EEEEEE 300%) !important';
      }

      return null;
    }
  },
  methods: {
    async goToDashboard() {
      await this.$store.dispatch("economicModel/get", {user: this.user.slug, year: this.year});
      await this.$store.dispatch("cos/get", {user: this.user.slug, year: this.year});
      await this.$router.push({ path: "/dashboard" });
    },
    async getSuccessProgress() {
      axios.get(this.userRoute + "/setup/success")
      .then(response => {
        this.progress = response.data;
      })
      .catch(error => {
        this.error(error);
      })
    },
    watchSection(section) {
      this.section = section;
      this.$bvModal.show('home-videos');
    },
  },
  mounted() {
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js')
    document.head.appendChild(recaptchaScript)
  }
};
</script>
<style lang="scss">
  .container {
    max-width: 1376px;
  }
  #welcome {
    padding-top: 70px;
    background-image: url("/img/brand/cn-bars.png"), linear-gradient(87deg, #3D5F71, #aaaaaa 300%);
    background-position: 99% 20%;
    background-repeat: no-repeat;
  }
  .bg-gradient-clarity2 {
    background-image: url("/img/brand/clarity-banner.png"), linear-gradient(87deg, #D45E5E, #D45E5E 300%);
    box-shadow: 0 0 5px rgba(4,4,4, .1);
  }
  .btn-outline-clarity {
    color: #D45E5E;
    background-color: #ffffff;
    border-color: #D45E5E;

    &:hover {
      color: #D45E5E;
    }
  }
  .text-clarity {
    color: #D45E5E;
  }
  .text-cblue {
    color: #3D5F71;
  }
  .text-cgray {
    color: #6F91A5;
  }
  .text-clight-blue {
    color: #C9F7FF;
  }
  .text-corange {
    color: #EF972C;
  }
  .text-cred {
    color: 3D5F71;
  }
  .text-clight-gray {
    color: #AAAAAA;
  }
  .card-img-overlay {
    background-color: transparent !important;
  }
</style>